import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import FrLoading from '../components/FrLoading'
import withReactContent from 'sweetalert2-react-content'

import api from '../services/api'
import FrSelect from '../components/FrSelect'

import './styles/Login.css';

import logo from '../imgs/LOGO_NOVO_TARENTO.bmp';
import delphus from '../imgs/delphus.png';

const swal = withReactContent(Swal)

function Login() {
    const [auth, setAuth] = useState(JSON.parse(localStorage['authtarento'] || JSON.stringify({ authenticated: false, user: 0})));   
    const [comboClientes, setComboClientes] = useState([{value: '', display: ''}])
    const [cliente, setCliente] = useState(0)
    const [gpu, setGpu] = useState(0)

    useEffect(()=>{
        {

            // api.get('usuarios/hash?'+auth.hash).then( r =>{         
            //     if (r.data[0] == auth.hash) {
            //         window.location.href = '/tarento/home'
            //     }             
            // }) 
            if (auth.authenticated){
                
                window.location.href = '/tarento/home'  
            }           
        }

        // window.alert(JSON.stringify(auth))
    }, [auth])

    const buscaClientes = (e) => {
        e.preventDefault()
        swal.fire({
            html: <FrLoading text="Carregando..." />,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false
        })
        let usu = e.target.value
        console.log(usu)
        api.get('/usuarios?login='+usu).then(r=>{
            if(r.data.length == 0){
                swal.close()
                swal.fire('Usuário Inválido', 'Usuário não foi encontrado no sistema!', 'warning')
                window.getElementById('login').setFocus()
            } else {
                setGpu(r.data[0].fk_gpu)
                if(r.data[0].fk_gpu == 1){
                    api.get('/clientes/combo').then(r => {
                        setComboClientes(r.data)
                        swal.close()
                        window.getElementById('senha').setFocus()
                    })
                } else{
                    api.get('/usuarios/comboClientes?login='+usu).then(r => {
                        console.log(r.data)
                        setComboClientes(r.data)
                        swal.close()
                    })

                }  
            }
        })
    }

    const handleChange = (e) =>{
        e.preventDefault()

        setCliente(e.target.value)
    }



    function login(e) {
        e.preventDefault();
        //Pega valores do form
        const form = document.getElementById('loginForm');
        const data = new FormData(form);

        if (data.get('login') === '') {
            swal.fire('Usuário não informado!', 'Informe o usuário.', 'warning')
            return
        }

        if (data.get('senha') === '') {
            swal.fire('Senha não informada!', 'Informe a senha.', 'warning')
            return
        }

        if(gpu==2){
            if (data.get('cliente') === '') {
                swal.fire('Cliente não informado!', 'Informe o cliente.', 'warning')
                return
            }
        }
        //Converte FormData em JSON
        var object = {};

        data.forEach(function(value, key){
            object[key] = value;
        });

        //Checa no servidor
        api.post('usuarios/login', object)
        .then(function (response) {
            console.log(response.data[0])
            let { pk_usu, nome, ultimo_login, grupo, gera_pedido } = response.data[0];
            if (pk_usu && pk_usu > 0) {
                api.defaults.headers.common['token'] = response.data.token;
                localStorage['authtarento'] =  JSON.stringify({ authenticated: true, user: pk_usu, name: nome, ultimo_login, last_activity: new Date(), grupo, fk_cli: Number(cliente),  gera_pedido: gera_pedido, access_token: response.data.token})
                window.location.href = '/tarento/home' 
            } else {
                swal.fire('Login inválido!', 'Verifique o Usuário e a Senha.', 'warning')
            }
        })
        .catch(function (error) {
            swal.fire('Login inválido!', 'Verifique o Usuário e a Senha.', 'warning')
        });
    }

    return (
        <div className="Login">
            <div className="form">
                <form className="form-signin" id="loginForm" onSubmit={login}>
                    <img alt="logo" src={logo} title="ejr" className="logo"/>
                    <div className="form-label-group">
                        <input type="text" id="login" name="login" className="loginInput" placeholder="Usuário" onBlur={buscaClientes}/>
                        <label htmlFor="login">Login</label>
                    </div>
                    <div className="form-label-group">
                        <input type="password" id="senha" name="senha" className="loginInput" placeholder="Senha"/>
                        <label htmlFor="senha">Senha</label>
                    </div>
                    {/* <div className="form-label-group"> */}

                        <FrSelect
                            style={{
                                width: 300, border: '1px solid #000000', marginRight: 0    
                            }}
                            name="cliente"
                            id="cliente"
                            label='Cliente'
                            data={comboClientes}
                            value={cliente}
                            onChange={handleChange}
                        />
                    {/* </div> */}
                    <button className="loginButton" type="submit" rel="nofollow">
                        <span><p className='loginButtonText'>Entrar</p></span>
                    </button>
                    <div className="forgotPwDiv">
                        <a href='/tarento/forgotPw'>Esqueci minha senha</a>
                    </div>

                </form>
            </div>
            <div className="delphus">
                <img alt="delphus" src={delphus} title="delphus" className="logo_delphus" />
            </div>
        </div>
    );
}

export default Login;
